import { Grid, Typography } from '@mui/material'
import theme from 'src/theme/index';
import { grey } from '@mui/material/colors';
import { memo } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import queryString from 'query-string';
import ModalReservation from 'src/Reservation/ModalReservation';
import CalendarVertical from 'src/SearchHours/components/calendars/CalendarVertical';
import { dayDefaultAvailableState, showCalendarHorizontalState } from 'src/SearchHours/components/calendars/state/atoms';
import FiltersSearch from 'src/SearchHours/FiltersSearch';
import useSearchHours from 'src/SearchHours/hooks/useSearchHours';
import { capitalizeWord, serializeDateFormatLong, nameSede } from 'src/shared/global/helpers';
//import ListProfessionals from './components/ListProfessionals';
import ListProfessionalsCentral from './components/ListProfessionalsCentral';
import ListImagenologia from './components/ListImagenologia';
import ListProcedimiento from './components/ListProcedimientosCentral';
import { daysAvailableState, filterSearchSelectedState, hoursAvailableState, loadingDaysCalendarState, loadingHoursState } from 'src/SearchHours/state/atoms';
import { useRef } from 'react';
import AlertCustom from 'src/shared/components/alerts/AlertCustom';
import HoursAvailableSkeleton from 'src/shared/components/skeletons/HoursAvailableSkeleton';
import useSEO from 'src/Hooks/useSEO';
import { activeTabState } from "src/SearchHours/state/atoms";
import EmptyCalendar from 'src/shared/components/notFoundData/EmptyCalendar';
import { mobileUserState } from "src/store/global/userMobileState";

const Index = memo(() => {
    const dayDefaultAvailable = useRecoilValue(dayDefaultAvailableState);
    const daysAvailable = useRecoilValue(daysAvailableState);
    const hoursAvailable = useRecoilValue(hoursAvailableState)
    const loadingHours = useRecoilValue(loadingHoursState);
    const setShowCalendarHorizontal = useSetRecoilState(showCalendarHorizontalState)
    //const [filterSearchSelected] = useRecoilState(filterSearchSelectedState);
    const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
        filterSearchSelectedState
      );

    const { loadDaysAvailableProcedimientoAndDefault, loadHoursProcedimientoAvailable, loadDaysAvailableAndDefault, loadHoursAvailable, isEmptyFilters, loadDaysAvailableImagenologiaAndDefault, loadHoursImagenologiaAvailable, isEmptyFiltersImagenologia } = useSearchHours();
    const loadingDaysCalendar = useRecoilValue(loadingDaysCalendarState)
    console.log("loadingDaysCalendar => ", loadingDaysCalendar);
    console.log("loadingHours => ", loadingHours);
    console.log("hoursAvailable => ", hoursAvailable);
    const location = useLocation();
    const query = queryString.parse(location.search)
    const mountedC = useRef(false);
    const query2 = queryString.parse(window.location.search)
    //useSEO({title: 'Reagendar'});
    //{query2 && query2.ra_id !== undefined && query2.ra_id !== "" && useSEO({title: 'Reagendar'})}

    const [activeTabSearch, setActiveTabSearchxx] = useRecoilState(activeTabState);
    const setActiveTabSearch = useSetRecoilState(activeTabState);
    const initSEO = () => {
        // if(query2 && query2.ra_id !== undefined && query2.ra_id !== ""){
        //     document.title = `Reagendar: ${nameSede(process.env.REACT_APP_SEDE)}`;
        //     const el = document.querySelector("meta[name='title']");
        //     el.setAttribute('content','Reagendar');
        // } else if(query2 && query2.qrp !== undefined && query2.qrp !== ""){
        //     document.title = `Agendar: ${nameSede(process.env.REACT_APP_SEDE)}`;
        //     const el = document.querySelector("meta[name='title']");
        //     el.setAttribute('content','Agendar');
        // } else {
        //     document.title = `Reserva de Hora: ${nameSede(process.env.REACT_APP_SEDE)}`;
        //     const el = document.querySelector("meta[name='title']");
        //     el.setAttribute('content','Reserva de Hora');            
        // }
    };

    useEffect(()=> {

        initSEO();
        
    }, [])

    useEffect(() => {
        mountedC.current = true;
        setShowCalendarHorizontal(true);
        //console.log("useEffect 0 => setShowCalendarHorizontal")
        return () => {
            mountedC.current = false;
            setShowCalendarHorizontal(false);
            // resetSearchAndResultHours()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        console.log("useEffect 1 - ResultSearchCentral");   
        console.log("CLINICA ==> ", filterSearchSelected.clinicaSelected.value);
        
        const queryParamsLength = !query ? 0 : Object.keys(query).length;
        console.log(`dayDefaultAvailable =>  ${dayDefaultAvailable} | queryParamsLength ${queryParamsLength} | loadingDaysCalendar ${loadingDaysCalendar}`);
        // // if (!dayDefaultAvailable && queryParamsLength === 0 && !loadingDaysCalendar && !isEmptyFilters()) {
        // //     console.log("useEffect 1 => loadDaysAvailableAndDefault");
        //     loadDaysAvailableAndDefault()
        // // }
        console.log("🔥🔥🔥🔥 activeTabSearch  🔥🔥🔥🔥 ==> ",activeTabSearch );
        if(filterSearchSelected.specialitySelected.value || filterSearchSelected.professionalSelected.value){
            console.log("🔥🔥🔥🔥CARGARRRRRR🔥🔥🔥🔥");
            setActiveTabSearch(1);
            loadDaysAvailableAndDefault()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadDaysAvailableAndDefault])

    useEffect(() => {
        console.log("useEffect 1 IMG");        
        const queryParamsLength = !query ? 0 : Object.keys(query).length;
        console.log(`dayDefaultAvailable =>  ${dayDefaultAvailable} | queryParamsLength ${queryParamsLength} | loadingDaysCalendar ${loadingDaysCalendar}`);
        if(filterSearchSelected.examenSelected.value){
            console.log("🔥🔥🔥🔥CARGARRRRRR🔥🔥🔥🔥");
            setActiveTabSearch(2);
            if (!dayDefaultAvailable && queryParamsLength === 0 && !loadingDaysCalendar && !isEmptyFiltersImagenologia()) {
                console.log("useEffect 1 => loadDaysAvailableImagenologiaAndDefault => imagenologia");
                loadDaysAvailableImagenologiaAndDefault()
            }            
            if (!isEmptyFiltersImagenologia()) {
                console.log("useEffect 1 => loadDaysAvailableImagenologiaAndDefault => imagenologia");
                loadDaysAvailableImagenologiaAndDefault()
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadDaysAvailableImagenologiaAndDefault])

    useEffect(() => {
        console.log("useEffect 1 - ResultSearchCentral - Procedimiento");   
        console.log("CLINICA ==> ", filterSearchSelected.clinicaSelected.value);
        
        const queryParamsLength = !query ? 0 : Object.keys(query).length;
        console.log(`dayDefaultAvailable =>  ${dayDefaultAvailable} | queryParamsLength ${queryParamsLength} | loadingDaysCalendar ${loadingDaysCalendar}`);
        // // if (!dayDefaultAvailable && queryParamsLength === 0 && !loadingDaysCalendar && !isEmptyFilters()) {
        // //     console.log("useEffect 1 => loadDaysAvailableAndDefault");
        //     loadDaysAvailableAndDefault()
        // // }
        console.log("🔥🔥🔥🔥 activeTabSearch  🔥🔥🔥🔥 ==> ",activeTabSearch );

        if(filterSearchSelected.servicioSelected.value){
            console.log("🔥🔥🔥🔥CARGARRRRRR🔥🔥🔥🔥");
            setActiveTabSearch(3);
            loadDaysAvailableProcedimientoAndDefault()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadDaysAvailableProcedimientoAndDefault])

    useEffect(() => {
        console.log("useEffect 2");

        if(filterSearchSelected.specialitySelected.value || filterSearchSelected.professionalSelected.value){
            if (dayDefaultAvailable && !loadingHours && hoursAvailable.length === 0) {
                console.log("useEffect 2 => loadHoursAvailable - ResultSearchCentral");
                loadHoursAvailable();
            }
        }
        if(filterSearchSelected.examenSelected.value){
            if (dayDefaultAvailable && !loadingHours && hoursAvailable.length === 0) {
                console.log("useEffect 2 => loadHoursImagenologiaAvailable");
                loadHoursImagenologiaAvailable();
                console.log(`dayDefaultAvailable ${dayDefaultAvailable} | loadingHours ${loadingHours} | hoursAvailable ${hoursAvailable}`);
            }            
        }

        if(filterSearchSelected.servicioSelected.value){
            //console.log("useEffect 2 => loadHoursProcedimientoAvailable");
            //console.log(`dayDefaultAvailable ${dayDefaultAvailable} | loadingHours ${loadingHours} | hoursAvailable ${hoursAvailable}`);
            if (dayDefaultAvailable && !loadingHours && hoursAvailable.length === 0) {
                console.log("useEffect 2 => loadHoursProcedimientoAvailable");
                loadHoursProcedimientoAvailable();
                console.log(`dayDefaultAvailable ${dayDefaultAvailable} | loadingHours ${loadingHours} | hoursAvailable ${hoursAvailable}`);
            }  
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dayDefaultAvailable])

    // const loadResultSearchCentral = useRecoilCallback(({ snapshot }) => async () => {
    //     const release = snapshot.retain();
    //     setLoading(true)
    //     try {
    //         //if (!mountedRef.current) return null;
    //         console.log('loadResultSearchCentral... index');
    
    //     } catch (error) {
    //         catchErrorApi(error)
    //         console.log(error);
    //     } finally {
    //         setLoading(false)
    //         release()
    //     }    
    //   }, []);

    // useEffect(()=> {

    //     console.log("oli!!!")
    //     //loadDaysAvailableAndDefault();
    //     //loadHoursAvailable();

    //     setFilterSearchSelected({
    //         ...filterSearchSelected,
    //         searchClick: {
    //             value: '',
    //             code: null
    //         },
    //       });
       
    //     //dayDefaultAvailable && !loadingHours && hoursAvailable.length 

    //     console.log(dayDefaultAvailable);
    //     console.log(loadingHours);
    //     console.log(hoursAvailable);


    // }, [filterSearchSelected.searchClick.value] )

    const setUserMobile = useSetRecoilState(mobileUserState);

    return (
        <>
        {/* <FiltersSearch /> */}
        {
            hoursAvailable.length > 0 && 
            <Typography variant='h3' color={theme.palette.primary.main} mb={2} style={{ textTransform: 'uppercase' }}>
                {serializeDateFormatLong(dayDefaultAvailable?.toISOString().split("T")[0])}
            </Typography>
        }
        <Grid
            container spacing={2}
        >
            {
                query && Object.keys(query).length > 0 && query.ra_id !== undefined && query.ra_id !== "" ?
                    <AlertCustom
                        severity="info"
                        children={
                            <>
                                Anteriormente realizó una reserva para el día <strong>{capitalizeWord(serializeDateFormatLong(new Date(sessionStorage.getItem("dateReservationCanceled"))?.toISOString().split("T")[0]), true)} con el Dr(a) {filterSearchSelected.professionalSelected.value}</strong>. Puede volver a agendar una nueva hora para el mismo día o la fecha que usted desee.
                            </>
                        }
                        style={{ marginBottom: 16, width: '100%' }}
                    /> : null
            }
            <ModalReservation />
           
            {/* <Grid item xs={12} md={8} lg={9}></Grid> */}
            
            <Grid item xs={12} md={7} lg={8} >

                { console.log('ResultSearchCentral index ==> ', activeTabSearch ) }

                {/* {
                    (loadingHours || loadingDaysCalendar) && hoursAvailable.length === 0 ? (<HoursAvailableSkeleton />)
                        : activeTabSearch == 1 ? <ListProfessionalsCentral /> : <ListImagenologia />
                } */}

                {
                    (loadingHours || loadingDaysCalendar) && hoursAvailable.length === 0 ? (<HoursAvailableSkeleton />)
                        : activeTabSearch == 1 ? <ListProfessionalsCentral /> : null
                }

                {
                    (loadingHours || loadingDaysCalendar) && hoursAvailable.length === 0 ? (<HoursAvailableSkeleton />)
                        : activeTabSearch == 2 ? <ListImagenologia /> : null
                }
               
               {
                    (loadingHours || loadingDaysCalendar) && hoursAvailable.length === 0 ? (<HoursAvailableSkeleton />)
                        : activeTabSearch == 3 ? <ListProcedimiento /> : null
                }
                {  hoursAvailable.length === 0 && daysAvailable.length > 0 && <EmptyCalendar text='No existe disponibilidad para los filtros seleccionados en el dia de hoy.'></EmptyCalendar>}
            </Grid>
            {
                daysAvailable.length > 0 &&
                (<Grid item md={5} lg={4} sx={{display: "flex", justifyContent: "center", height: "325px", position: "sticky", top: "95px"}} >
                    <CalendarVertical />
                </Grid>)
            }
            {
                daysAvailable.length > 0 ?  setShowCalendarHorizontal(true) : setShowCalendarHorizontal(false)
            }
            {
                daysAvailable.length > 0 ?  setUserMobile(false) : setUserMobile(true)
            }
            {/* <Grid item md={4} >
              {
                hoursAvailable.length > 0 ?   <CalendarVertical /> : null
              }
            </Grid> */}

        </Grid>
        </>
    )
})


export default Index;